import Modal from "Common/Components/Modal";
import { Pencil } from "lucide-react";
import React from "react";

interface ProductImageProps {
    productImages: any[];
    onStatusChange: (color: string) => void;
    onImageSaved: () => void;
    // onHide: () => void;
}

export const ProductImages: React.FC<ProductImageProps> = ({ productImages, onStatusChange, onImageSaved }) => {
    return (
        <React.Fragment>
            <Modal.Header className="bg-custom-200 dark:bg-custome-700 flex items-center justify-between p-4 border-b dark:border-zink-300/20"
                closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
                <Modal.Title className="text-16">{"Product Images"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
                <div className="flex items-center justify-end" style={{ flexDirection: 'row', width: 600, height: 180, display: 'flex', flexWrap: 'wrap' }}>
                    {productImages?.map((file: any, index: number) => (
                        <div style={{ marginRight: 10 }} className="border rounded border-slate-200 dark:border-zink-500" key={"dropzone-preview-list2" + index}>
                            <div className="p-2 text-center">
                                <div>
                                    <div className="p-2 mx-auto rounded-md size-20 bg-slate-100 dark:bg-zink-600">
                                        <img className="block w-full h-full rounded-md" src={file.preview} alt={file.name} />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <input type="checkbox" checked={file.selected} onChange={() => onStatusChange(file.name)} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    {/* <button type="reset" onClick={onHide} data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" >Cancel</button> */}
                    <button type="button" onClick={onImageSaved} className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                        Save
                    </button>
                </div>
            </Modal.Body>
        </React.Fragment>
    )
}

